import { ModuleType } from '../models/other-module'

export interface IService {
  serviceId: string
  serviceCode: string
  route: any[]
  displayName: string
  moduleType: ModuleType
  iconName: string
  name: string
  position: number
  id?: string
}

export const serviceCode = {
  AR: 'AR_45309S',
  DOC: 'DO_769655',
  FAQ: 'FA_39541S',
  PG: 'PG_27488S',
  DT: 'DT_29891S',
  LMS: 'LMS_29891S',
  SOP: 'SOP_45539S',
  LMS_ASSESSMENT: 'LMS_A_29891S'
}

export const Services: IService[] = [
  {
    serviceCode: serviceCode.PG,
    serviceId: '',
    displayName: 'Picture Guide',
    name: 'Picture Guide',
    route: [
      { name: 'Create', url: '/picture-guide/choose-format' },
      { name: 'Manage Library', url: '/picture-guide/manage-library' }
    ],
    moduleType: ModuleType.PG,
    iconName: 'picture-guide',
    position: 0
  },
  {
    serviceCode: serviceCode.DT,
    serviceId: '',
    route: [
      { name: 'Create', url: '/decision-tree/choose-format' },
      { name: 'Manage Library', url: '/decision-tree/manage-library' }
    ],
    displayName: 'Decision Tree',
    name: 'Decision Tree',
    moduleType: ModuleType.DT,
    iconName: 'call-handling',
    position: 0
  },
  {
    serviceCode: serviceCode.FAQ,
    serviceId: '',
    route: [
      { name: 'Create', url: '/faq/choose-format' },
      { name: 'Manage Library', url: '/faq/manage-library' }
    ],
    displayName: 'FAQ',
    name: 'FAQ',
    moduleType: ModuleType.FAQ,
    iconName: 'faq',
    position: 0
  },
  {
    serviceCode: serviceCode.AR,
    serviceId: '',
    route: [
      { name: 'Create', url: '/article/choose-format' },
      { name: 'Manage Library', url: '/article/manage-library' }
    ],
    displayName: 'Articles',
    name: 'Articles',
    moduleType: ModuleType.Article,
    iconName: 'article',
    position: 0
  },
  {
    serviceCode: serviceCode.DOC,
    serviceId: '',
    route: [
      { name: 'Create', url: '/document/choose-format' },
      { name: 'Manage Library', url: '/document/manage-library' }
    ],
    displayName: 'Document',
    name: 'Document',
    moduleType: ModuleType.Document,
    iconName: 'document',
    position: 0
  },
  {
    serviceCode: serviceCode.LMS,
    serviceId: '',
    route: [
      { name: 'Create', url: '/lms/choose-format' },
      { name: 'COMMON.assign', url: '/lms/assignment' },
      { name: 'Manage Library', url: '/lms/manage-library' }
    ],
    displayName: 'Quiz',
    name: 'Lms',
    moduleType: ModuleType.LMS,
    iconName: 'article',
    position: 0
  },
  {
    serviceCode: serviceCode.LMS_ASSESSMENT,
    serviceId: '',
    route: [
      { name: 'Create', url: '/lms/choose-format' },
      { name: 'schedule', url: '/lms/assignment' },
      { name: 'Manage Library', url: '/lms/manage-library' }
    ],
    displayName: 'Quiz',
    name: 'Lms',
    moduleType: ModuleType.LMS,
    iconName: 'article',
    position: 0
  },
  {
    serviceCode: serviceCode.SOP,
    serviceId: '',
    route: [
      { name: 'Create', url: '/sop/choose-format' },
      { name: 'Manage Library', url: '/sop/manage-library' }
    ],
    displayName: 'SOP',
    name: 'SOP',
    moduleType: ModuleType.SOP,
    iconName: 'sop',
    position: 0
  }
]

export enum serviceType {
  AR = 'AR',
  FAQ = 'FAQ',
  DOC = 'DOC',
  PG = 'PG',
  DT = 'DT',
  SOP = 'SOP',
  LMS = 'LMS'
}

export enum Module {
  Article = 'article',
  DecisionTree = 'decision-trees',
  PictureGuide = 'pg',
  FAQ = 'faq',
  Document = 'document',
  SOP = 'sop',
  LMS = 'quiz'
}

export const serviceTypeToModule: Partial<Record<serviceType, Module>> = {
  [serviceType.AR]: Module.Article,
  [serviceType.DT]: Module.DecisionTree,
  [serviceType.PG]: Module.PictureGuide,
  [serviceType.FAQ]: Module.FAQ,
  [serviceType.DOC]: Module.Document,
  [serviceType.SOP]: Module.SOP,
  [serviceType.LMS]: Module.LMS
}

export const serviceTypeToPreviewType: Partial<Record<serviceType, string>> = {
  [serviceType.AR]: 'article',
  [serviceType.DT]: 'decision-trees',
  [serviceType.PG]: 'picture-guide',
  [serviceType.FAQ]: 'faq',
  [serviceType.DOC]: 'document',
  [serviceType.SOP]: 'sop',
  [serviceType.LMS]: 'lms'
}

export const servicesName = {
  Articles: 'Articles',
  Lms: 'Quiz',
  FAQ: 'FAQ',
  Document: 'Document',
  SOP: 'SOP',
  'Decision Tree': 'Decision Tree',
  'Picture Guide': 'Picture Guide'
}

// export serviceEnum =  typeof serviceType
